import React from 'react'
import { DateTime } from 'luxon'
import { Badge } from 'reactstrap'
import { Link } from 'react-router-dom'

const Entry = ({ entry, deleteEntry, searchEntries }) => {
  const date = DateTime.fromISO(entry.date).setLocale("fi")

  const hasTags = entry.tags && entry.tags.length > 0

  return (
    <div className="entry">
      <div onClick={() => deleteEntry(entry.guid)} className="delete pull-right"><i className="fas fa-trash" /></div>
      <h2>{date.toFormat('EEE dd.MM.yyyy')}</h2>
      <p>{entry.text}</p>
      {hasTags && (
        <div>
          {entry.tags.map((tag, index) => {
            const tagName = tag.tag.replace('#', '')
            if (tag.value) {
              return (
                <Link to={`/tag/${tagName}`} key={index}>
                  <Badge color="info">{tag.tag} {tag.value}</Badge>
                </Link>
              )
            } else {
              return (
                <Badge
                  color="info"
                  onClick={() => searchEntries(tag.tag)}
                  key={index}>
                  {tag.tag}
                </Badge>
              )
            }
          })}
        </div>
      )}
    </div>
  )
}

export default Entry
